import classnames from 'classnames/bind'
import { GlobalTextPreset } from '~/@types/text-preset'

import { useStyle } from '~/providers/StyleProvider'

import AccordionPanel, {
  AccordionPanelProps,
} from '../Abstracts/Accordion/AccordionPanel'
import { ArrowIcon } from '../UI/Icons'
import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface AccordionPanelUiProps {
  className?: string
  title: string
  body: AccordionPanelProps['body']
}

function AccordionPanelUi({ className, title, body }: AccordionPanelUiProps) {
  const selectOptionTextStyle = useStyle({
    textPreset: GlobalTextPreset.Cta12Primary,
  })
  return (
    <AccordionPanel
      index={0}
      className={cx(className, css.AccordionPanelUi)}
      head={() => (
        <div className={cx(css.head)}>
          <span className={cx(css.customizationTitle, selectOptionTextStyle)}>
            {title}
          </span>
          <ArrowIcon className={css.arrowIcon} />
        </div>
      )}
      body={body}
    />
  )
}

AccordionPanelUi.defaultProps = {}

export default AccordionPanelUi
